export const OVERVIEW_PATH = '/overview'
export const CMS_PATH = '/cms/:serviceName'
export const ACCOUNT_PATH = '/account'
export const LOGIN_PATH = '/login'
export const SIGNUP_PATH = '/signup'
export const EDIT_ITEM_PATH = 'edit/:itemId'
export const CREATE_ITEM_PATH = 'create'
